<template>
  <div class="c-slider" @click="$emit('on-select')">
    <div class="c-slider-wrap" :class="{ 'c-active-check': active }">
      <div class="c-complete" :style="{ backgroundColor: color, height: `${height}px` }"></div>
      <div v-show="active" class="c-corn">
        <Button shape="circle" icon="md-arrow-up" @click.stop="$emit('on-prev')" />
        <Button shape="circle" icon="md-arrow-down" @click.stop="$emit('on-next')" />
        <Button shape="circle" icon="md-trash" @click.stop="$emit('on-delete')" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sliderConponent',
  props: {
    attr: {
      type: Array,
      default() {
        return []
      }
    },
    index: {
      type: Number
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    color() {
      let color = '#fff'
      const index = this.attr.findIndex((ret) => ret.name === 'color')
      if (index > -1) color = this.attr[index].color
      return color
    },
    height() {
      let height = 50
      const index = this.attr.findIndex((ret) => ret.name === 'height')
      if (index > -1) height = this.attr[index].height
      return height
    }
  }
}
</script>
<style lang="scss" scoped>
.c-slider {
  width: 100%;
  position: relative;

  .c-slider-wrap {
    position: relative;
    width: 375px;
    margin: 0 auto;
    box-shadow: 1px 1px 7px 1px #e8e8e8;

    &.c-active-check {
      border: solid 1px #4b77ee;

      &:before {
        content: '';
        position: absolute;
        z-index: -1;
        width: 3840px;
        height: inherit;
        background-color: #e8e9eb;
        left: -1920px;
        top: -1px;
      }

      i,
      span {
        color: #4b77ee;
      }
    }

    .c-complete {
      width: 100%;
      transition: background 0.12s ease, height 0.12s ease;
    }

    .c-corn {
      width: 32px;
      min-height: 96px;
      position: absolute;
      z-index: 4;
      top: 0px;
      right: -52px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
</style>
